export const BUS_SLASH_MENU_SHOW_CHAT_WITH_AI = 'slash-menu:show-chat-with-ai'